style= require('./edit-player-source.styl')

.modal-header
  .modal-title='Override'
  ft-icon.close(name='ui--cross', (click)= this.closeModal())
if player
  .custom
    .block
      label='First Name'
      ft-form-control(
        type="text",
        [(value)]=player.firstName)
    .block
      label='Last Name'
      ft-form-control(
        type="text",
        [(value)]=player.lastName)
    .block
      label='Gender'
      select((change)=this.editPlayerGender(player, e.target.value))
        option(disabled selected)='Select gender'
        for gnd in genders
          option(
            value=gnd,
            selected=(player?.gender === gnd)
          )= gnd
    .block
      label='Country'
      select((change)=this.editPlayerCountry(player, e.target.value))
        option(disabled selected)='Select country'
        for cnt in countries
          option(
            value=cnt.alpha2,
            selected=(player?.country === cnt.alpha2)
          )= cnt.name
    .block
      label='Position'
      ft-dropdown.dropdown(icon)
        header.dropdown-header(slot="header")
          span.dropdown-text=this.position || ' <any position>'
        each pos in positions
          .dropdown-item(role='option', value=pos, (click)=this.editPlayerTeamPos(player, 'position', null, pos),
            selected= player?.position === pos)= pos
    .block
      label='Shirt'
      ft-form-control(
        type="text",
        [(value)]=player.shirt)
    .block
      label='Team'
      select((change)=this.editPlayerTeamPos(player, 'overrideTeam', e.target.value))
        option(disabled selected)='Select team'
        for team in sortedTeams
          option(
            value=team,
            selected=(player?.team === team)
          )= team.name

    .block
      label='Custom Name'
      ft-form-control(
        type="text",
        [(value)]=player.customName)
    if season && season.sport === 'dota2'
      .block
        label='UID'
        ft-form-control(
          type="number",
          [(value)]=player.uid)
    if getPrice(player)
      .block(short=getPrice(player))
        label='Status'
        ft-toggle.sub(
          checked=getPrice(player).disabled,
          (change)=this.toggleDisabled(player),
        )='N/A'
    else
      .block
        label='Status'
        ft-toggle.sub(
          checked,
          disabled
        )='N/A'
    - const csvSource = getCsvSource()
    if csvSource
      .block
        ft-form-control(
          type="textarea",
          [(value)]=this.csvUploadData)
        ft-button(
          disabled=!this.canUploadCsv,
          warning,
          (click)=this.uploadCsv()) Submit CSV
  .modal-footer
    ft-button.save(success, (click)=this.closeModal(true))="Save"
